import performRequestBackend from "../axios/index";
const TF = {
  addAccessToken: async (authCode) => {
    console.log(authCode);
    const response = await performRequestBackend("/authenticate", "POST", {
      authCode,
    });
    return response;
  },

  getHoldings: async () => {
    const response = await performRequestBackend("/user/holdings", "GET");
    return response;
  },

  placeOrder: async (body) => {
    const response = await performRequestBackend("/stock/place-order", "POST", {
      ...body,
    });
    return response;
  },

  fetchStockDetails: async (body) => {
    const response = await performRequestBackend("/stock/fetch", "POST", {
      ...body,
    });
    return response;
  },
  fetchAlerts: async () => {
    const response = await performRequestBackend("/alerts", "GET");
    return response;
  },

  getSmartAlerts: async ({
    limit = 10,
    offset = 0,
    sort_by = "trigger_count",
    sort_order = "desc",
  }) => {
    const response = await performRequestBackend(
      "/alerts/enhanced",
      "GET",
      {},
      {
        limit,
        offset,
        sort_by,
        sort_order,
      }
    );
    return response;
  },

  addComment: async (body) => {
    const response = await performRequestBackend("/symbol/comments", "POST", {
      trading_symbol: body.trading_symbol,
      comment: body.comment,
      category: body.category,
      sentiment: body.sentiment,
    });
    return response;
  },

  getComments: async (symbol) => {
    const response = await performRequestBackend(
      `/symbol/comments/${symbol}`,
      "GET"
    );
    return response;
  },
  getUserInfo: async () => {
    const response = await performRequestBackend("/user/info", "GET");
    return response;
  },
};

export default TF;
